export default __webpack_public_path__ + "static/media/signature.e280e5d5.png";